import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Col, Container, Row, Tab, Tabs } from 'react-bootstrap'
import { MagnifyingGlass } from '../../../constant/icons/icons'
import { useLoader } from "../../../context/LoaderContext";
import { fetchAllCampaigns } from '../../../store/campaignSlice';
import moment from 'moment';
import { campaignStatusArr } from '../../../constant/data';
import PaginationComponent from '../pagination/pagination';

const List = () => {
  const limit = 10;
  const { setLoading } = useLoader();
  const dispatch = useDispatch();
  // Toast
  // const [showSnackbar, setShowSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarVariant, setSnackbarVariant] = useState("success");
  // search bar
  const [searchTerm, setSearchTerm] = useState("");
  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  // const [openDropdown, setOpenDropdown] = useState({ id: null, type: null });
  const [activeTab, setActiveTab] = useState("");

  const {data = [], total = 0} = useSelector((state) => state?.campaign?.allCampaigns || {});
  
  // console.log("data",data,"total",total);

    const getAllCampaigns = useCallback(() => {
      setLoading(true);
      dispatch(fetchAllCampaigns({
        offset:currentPage,
        limit,
        search: searchTerm,
        status:activeTab
      }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }, [dispatch, currentPage, limit, searchTerm, activeTab, setLoading]);
  
    useEffect(() => {
      getAllCampaigns();
    }, [getAllCampaigns]);

    // Tab Handler
    const handleTabSelect = (key) => {
      console.log("key",key);
      
      if (key === "") {
        setCurrentPage(0);
        setActiveTab(null); 
      } else {
        setCurrentPage(0);
        setActiveTab(key);
      }
      setCurrentPage(0); 
    };

    // Pagination Handler
    const handlePageChange = (newPageNumber) => {
      setCurrentPage(newPageNumber - 1);
    };

  return (
    <>
      {/* <ToastContainer position="top-end" className=" pt-3 pe-3 cu-toster">
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
        >
          <Toast.Body className="d-flex align-items-center gap-2 text-white">
            <CheckCircle size={22} color="#ffffff" weight="duotone" />
            <p className="mb-0">{snackbarMessage}</p>
          </Toast.Body>
        </Toast>
      </ToastContainer> */}

        {/* Background color of a page */}
        <div className="bg-primary pt-10 pb-21"></div>
      <Container fluid className="mt-n22 px-6 pb-6">
        <Row>
          <Col lg={12} md={12} xs={12}>
            <div>
              <div>
                <h3 className="mb-0 fw-semibold pg-title text-white">
                  All Campaigns
                </h3>
              </div>
            </div>
          </Col>

            <Col xl={12} lg={12} md={12} xs={12} className="mt-6">
              <div className="position-relative rounded-3 bg-white  tablecontainer">
                <div className="d-flex align-items-center justify-content-between gap-3 reseller-sea-btn mb-3">
                  <div className="position-relative">
                    <input
                      type="text"
                      placeholder="Search "
                      className="searchbar outline-none border-0 shadow-none "
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                    />
                    <MagnifyingGlass
                      size={18}
                      color="#757779"
                      className="position-absolute top-50 start-0 ms-4 translate-middle"
                      weight="regular"
                    />
                  </div>
                </div>

                {/* Tabs section */}
                <div className="position-relative overflow-hidden rounded-2 bg-white table-tabs mb-3">
                  <Tabs
                    defaultActiveKey=""
                    className="pb-0 table-tabs-items"
                    id="uncontrolled-tab-example"
                    onSelect={handleTabSelect}
                  >
                    {campaignStatusArr?.map((item) => (
                      <Tab
                        eventKey={item?.key}
                        title={
                          <>
                            <div className="d-flex align-items-center gap-2">
                              <p className="mb-0">{item?.title}</p>
                            </div>
                          </>
                        }
                      ></Tab>
                    ))}
                   
                  </Tabs>
                </div>

                {/* Table */}
                 <div  className="table-responsive rounded-2 mt-5 custom_table pg-table-scroll overflow-y-auto">
                  <table className="w-100">
                    <thead>
                      <tr>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">campaign Name</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("name")}
                            >
                              {/* {renderSortIcons("name")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Customer</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("name")}
                            >
                              {/* {renderSortIcons("name")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Organization</p>
                            <span
                              className="d-flex align-items-center"
                            >
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Send Type</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Status</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Recipients</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Credit Used</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Test Credit</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        <th className="fw-medium">
                          <div className="d-flex align-items-center gap-th">
                            <p className="mb-0 ">Created at</p>
                            <span
                              className="d-flex align-items-center"
                              // onClick={() => handleSort("credit_rate")}
                            >
                              {/* {renderSortIcons("credit_rate")} */}
                            </span>
                          </div>
                        </th>
                        {/* <th className="fw-medium">
                          <div className="d-flex align-items-center justify-content-center gap-th">
                            <p className="mb-0">Action</p>
                          </div>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                    {data?.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center border-bottom-0">
                          <p className="mt-5 mb-0 no-data text-capitalize">
                            No data available
                          </p>
                        </td>
                      </tr>
                    ) : (
                      data?.map((item,i) => (
                        <tr
                          key={item?.id}
                          className={`position-relative ${item.status === "placed" ? "cursor-pointer" : ""}`}>
                          <td>{item?.name ? item?.name : "-"}</td>
                          <td>{item?.client_event?.name ? item?.client_event?.name : "-"}</td>
                          <td>{item?.client_event?.name ? item?.customer?.name : "-"}</td>
                          <td>{item.template_type ? item?.template_type === "text" ? "Only Message" : "With Invitation Card" :"-"}</td>
                          <td>{item?.status ? 
                           <Badge pill bg={item?.status === "completed" ? "success" : item?.status === "in-process" ? "warning" : item?.status === "pending" ? "warning" : item?.status === "drafted" ? "primary" : item?.status === "scheduled" ? "info" : "danger"}>
                               {item?.status}
                           </Badge> : "-"}</td>
                          <td>{item?.client_guests_not_test_count ? item?.client_guests_not_test_count : "-"}</td>

                          <td>{item ? item?.total_credits - item?.client_guests_test_count : "-" }</td>

                          <td>{item?.client_guests_test_count}</td>

                          <td>{item?.created_at ? moment(item?.created_at).format("DD/MM/YYYY hh:mm A") : "-"}</td>  

                          {/* <td className="text-center">
                          <ActionMenu item={item} isOpen={openDropdown.id === item.id && openDropdown.type === "action"} toggleMenu={() => handleDropdownToggle(item.id, "action")} />
                        </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                  </table>
                </div>

                {total > limit && (
                <div className="pt-4">
                  <PaginationComponent
                    totalItems={total}
                    itemsPerPage={limit}
                    currentPage={currentPage + 1}
                    onPageChange={handlePageChange}
                  />
                </div>
               )} 
              </div>
             </Col>
          </Row>
      </Container>
    </>
  )
}

export default List